import React from 'react'

import Image from '../layouts/Image.jsx'

import marketing1Img from '_static/img/audience-insights/marketing/slide1.png'
import marketing2Img from '_static/img/audience-insights/marketing/slide2.png'
import marketing3Img from '_static/img/audience-insights/marketing/slide3.png'
import marketing4Img from '_static/img/audience-insights/marketing/slide4.png'
import marketing5Img from '_static/img/audience-insights/marketing/slide5.png'
import marketing6Img from '_static/img/audience-insights/marketing/slide6.png'

const SLIDES = {
  1: {
    url: marketing1Img,
    footerTheme: { background: 'light', icon: 'light', page: 'dark' },
  },
  2: {
    url: marketing2Img,
    footerTheme: { background: 'light', icon: 'dark', page: 'light' },
  },
  3: {
    url: marketing3Img,
    footerTheme: { background: 'light', icon: 'dark', page: 'light' },
  },
  4: {
    url: marketing4Img,
    footerTheme: { background: 'light', icon: 'dark', page: 'light' },
  },
  5: {
    url: marketing5Img,
    footerTheme: { background: 'dark', icon: 'light', page: 'light' },
  },
  6: {
    url: marketing6Img,
    footerTheme: { background: 'light', icon: 'light', page: 'dark' },
  },
}

const Marketing = ({ slideNum, index }) => (
  <Image
    imageUrl={SLIDES[slideNum].url}
    page={index + 1}
    footerTheme={SLIDES[slideNum].footerTheme}
  />
)

export default Marketing
